<template>
  <div>
    <div class="footer">
      <div class="footer-content">
        <div class="footer-logo">
          <img
            src="@/assets/images/zy_write.png"
            alt
            class="footerlogo"
            draggable="false"
          />
        </div>
        <div class="footer-info">
          <div class="company-names">
            <div class="company-item">
              <div class="company-name">上海早鹰培优信息技术有限公司</div>
              <div class="company-address">上海市闵行区集心路268号二楼  151-021-11688</div>
            </div>
            <div class="company-item">
              <div class="company-name">江苏早鹰培优信息技术有限公司</div>
              <div class="company-address">江苏省南通市中央公园广场1401室  0513-83882000</div>
            </div>
            <div class="company-item">
              <div class="company-name">南通早鹰文化发展有限公司</div>
              <div class="company-address">江苏省南通市启东市人民中路773-2号</div>
            </div>
            <div class="company-item">
              <div class="company-name">青岛早鹰信息科技有限公司</div>
              <div class="company-address">
                山东省青岛市西海岸新区（黄岛）映山红路1117号二楼
              </div>
            </div>
          </div>
          </div>
        <div class="qrcode-section">
          <div class="qrcode-section-title">关注我们</div>
          <div class="qrcode-section-item">
            <a href="javascript:void(0)" class="qrcode-item">
              <img src="@/assets/images/ZYJT.jpg" />
              <p>早鹰集团公众号</p>
            </a>
            <a href="javascript:void(0)" class="qrcode-item">
              <img src="@/assets/images/ZYPYDY.png" />
              <p>早鹰培优抖音号</p>
            </a>
          </div>
          <div class="contact-email">业务咨询邮箱：contact@zaoying.com</div>
        </div>
      </div>
      <hr class="footerhr" />
      <div class="footercopyright">
        <span>Copyright © 2024 Zao Ying Group Limited Liability Company. All rights reserved.</span>
        <span><a href="https://beian.miit.gov.cn/" target="_blank">备案号：沪ICP备2022000823号</a></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.footer {
  width: 100%;
  background-color: #111827;
  padding: 30px 0;
}

.footer-content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 280px 1fr auto;
  gap: 60px;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
}

.footer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footerlogo {
  width: 240px;
  display: block;
}

.footer-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: 15px;
}

.company-names {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 40px;
  color: #ffffff;
  font-weight: bold;
  text-align: left;
  width: 100%;
}

.company-item {
  display: flex;
  font-size: 14px;
  flex-direction: column;
  gap: 5px;
}

.company-name {
  color: #ffffff;
  font-weight: bold;
}

.company-address {
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  justify-content: center;
}

.qrcode-section-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.qrcode-section-item {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  text-decoration: none;
}

.qrcode-item:hover {
  transform: scale(1.05);
}

.qrcode-item img {
  width: 130px;
  height: 130px;
}

.qrcode-item p {
  margin: 10px 0 0 0;
  font-size: 14px;
  color: #ffffff;
  text-decoration: none;
}

.contact-email {
  display: flex;
  color: #ffffff;
  font-size: 13px;
  justify-content: center;
  text-align: center;
  margin-top: 10px;
  opacity: 0.8;
}

.footerhr {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.footercopyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  color: #ffffff;
  font-size: 12px;
  box-sizing: border-box;
}
.footercopyright span a {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
</style>